// Safari leaves clicked buttons unfocused. Focus them before the dialog's
// onClick runs, so its focus lock records the opener rather than Gatsby's wrapper.
export function focusPointerControl(event: MouseEvent): void {
  if (event.detail === 0) return;
  const target = event.target as Element | null;
  if (target?.closest?.('input, select, textarea, [contenteditable="true"]')) return;
  const control = target?.closest?.<HTMLElement>('button, a[href], [role="button"], [tabindex]:not([tabindex="-1"])');
  if (!control || control.matches(':disabled') || control.getAttribute('aria-disabled') === 'true') return;
  control.focus({ preventScroll: true });
}
